// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"ActivityLogsList_tableContainer__3x7pK","icon":"ActivityLogsList_icon__2rXzR"};